import React, { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
const AccessContext = createContext(null);
function recoveryFlag(value) {
  try {
    if (value === true) sessionStorage.setItem("proscore-password-recovery", "1");
    if (value === false) sessionStorage.removeItem("proscore-password-recovery");
    return sessionStorage.getItem("proscore-password-recovery") === "1";
  } catch { return false; }
}
export function AccessProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(Boolean(supabase));
  const [recovery, setRecovery] = useState(() => recoveryFlag());
  const [sessionError, setSessionError] = useState("");
  const finishRecovery = () => { recoveryFlag(false); setRecovery(false); };
  useEffect(() => {
    if (!supabase) return undefined;
    let active = true, revision = 0, eventSeen = false;
    function receive(session, event) {
      const current = ++revision;
      if (!active) return;
      if (event === "PASSWORD_RECOVERY") { recoveryFlag(true); setRecovery(true); }
      setSessionError("");
      if (!session) {
        setUser(null); setLoading(false); recoveryFlag(false); setRecovery(false); return;
      }
      setUser(null); setLoading(true);
      // Auth callbacks stay synchronous; provider verification runs after their lock is released.
      setTimeout(async () => {
        if (!active || current !== revision) return;
        try {
          const { data, error } = await supabase.auth.getUser(session.access_token);
          if (!active || current !== revision) return;
          if (error || !data.user) {
            setUser(null); setSessionError("Impossible de vérifier ta session. Reconnecte-toi.");
          } else setUser({ id: data.user.id, email: data.user.email });
        } catch {
          if (active && current === revision) { setUser(null); setSessionError("Impossible de vérifier ta session. Vérifie ta connexion."); }
        } finally { if (active && current === revision) setLoading(false); }
      }, 0);
    }
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => { eventSeen = true; receive(session, event); });
    supabase.auth.getSession().then(({ data, error }) => {
      if (!active || eventSeen) return;
      if (error) { setLoading(false); setSessionError("Ce lien a expiré. Reconnecte-toi ou demande un nouvel e-mail."); }
      else receive(data.session, "INITIAL_SESSION");
    }).catch(() => { if (active && !eventSeen) setLoading(false); });
    return () => { active = false; revision++; subscription.unsubscribe(); };
  }, []);
  // Authentication does not grant a subscription; paid access must be checked by the server.
  return <AccessContext.Provider value={{ user, loading, recovery, finishRecovery, sessionError, configured: Boolean(supabase), preview: true }}>{children}</AccessContext.Provider>;
}
export function useAccess() {
  const value = useContext(AccessContext);
  if (!value) throw new Error("AccessProvider absent");
  return value;
}
